import { Directive } from '@angular/core';

@Directive( {
    //   selector: '[ridangoPlaceholder]'
    // tslint:disable-next-line:directive-selector
    selector: 'ridango-placeholder'
} )
export class PlaceholderDirective {

    constructor() { }

}
